export default __webpack_public_path__ + "static/media/icon_kreise.ca794c77.png";